import { render, staticRenderFns } from "./ProductGeneral.vue?vue&type=template&id=46d2fb98"
import script from "./ProductGeneral.vue?vue&type=script&lang=js"
export * from "./ProductGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports